import React from 'react'
import cx from 'classnames'

import ColorPicker from 'layouts/ColorPickerTouchless'

import './style.css'

const PALETTE = [
  '#0176FF', '#f93a1f', '#f4b806', '#00cd6a', '#9b5fbc', '#50626a'
]

export const Swatch = ({ color, onClick, selected, className }) => (
  <div
    className={cx('color-palette-swatch-container', { selected }, className )}
    onClick={onClick}
    style={{
      color,
    }}
  >
    <div
      className="color-palette-swatch"
      style={{
        backgroundColor: color,
      }}
    />
  </div>
)

const ColorPalette = ({
  color,
  onColorClick,
  backgroundColor = '#' + color,
}) => {
  return (
    <div className="color-palette">
        {PALETTE.map(newColor => (
          <Swatch key={newColor} color={newColor} selected={backgroundColor === newColor} onClick={onColorClick(newColor)}/>
        ))}
        <ColorPicker />
    </div>
  )
}
export default ColorPalette


// WEBPACK FOOTER //
// ./src/layouts/ColorPalette/component.js